<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>Owners</template>

    <Sheet.Body>
      <EntityListBody
        subtitle="Owners of this registered work"
        :entities="entities"
        :loading="loading"
      />
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, useSheet } from '@dacr/library'
import { CloseIcon } from '@dacr/icons'

import type { CopyrightFile } from '@/features/copyright/composables/useCopyrightFile'
import EntityListBody from './EntityListBody.vue'
import { useAllOwners } from './useAllEntities'

const props = defineProps<{
  file: CopyrightFile
}>()

const { close } = useSheet()
const { entities, loading } = useAllOwners(props.file)
</script>
